import styled from 'styled-components';

import theme from './Theme';

const StyledDataIcon = styled.img`
  height: 16px;
  width: 16px;
  margin-right: ${theme.spacingS};
  background: ${theme.secondaryColor};
  padding: 2px;
  border-radius: 2px;
`;

export default StyledDataIcon;
